module.exports = __webpack_public_path__ + "img/16.ded80b65.jpg";